import { ref } from "vue";
import type { LightboxSlide } from "./lightboxContract";
import { parseLightboxGroup } from "./parseLightboxGroup";

export interface LightboxState {
  isOpen: boolean;
  slides: LightboxSlide[];
  activeIndex: number;
  groupKey: string;
}

const state = ref<LightboxState>({
  isOpen: false,
  slides: [],
  activeIndex: 0,
  groupKey: "",
});

export function useLightboxState() {
  return state;
}

export function openLightbox(clickedAnchor: HTMLAnchorElement): boolean {
  const result = parseLightboxGroup(clickedAnchor);
  if (!result || result.slides.length === 0) return false;

  state.value = {
    isOpen: true,
    slides: result.slides,
    activeIndex: result.activeIndex,
    groupKey: result.groupKey,
  };
  return true;
}

export function closeLightbox() {
  state.value = {
    ...state.value,
    isOpen: false,
  };
}

export function goToSlide(index: number) {
  if (index < 0 || index >= state.value.slides.length) return;
  state.value = {
    ...state.value,
    activeIndex: index,
  };
}

export function goNext() {
  const next = (state.value.activeIndex + 1) % state.value.slides.length;
  goToSlide(next);
}

export function goPrev() {
  const len = state.value.slides.length;
  const prev = (state.value.activeIndex - 1 + len) % len;
  goToSlide(prev);
}

export function getCurrentSlide(): LightboxSlide | null {
  const s = state.value;
  if (!s.isOpen || s.slides.length === 0) return null;
  return s.slides[s.activeIndex] ?? null;
}
